import React from 'react';
// import PropTypes from 'prop-types';
import Footer from '../../organisms/shared/footer/Footer';
import Header from '../../organisms/shared/header/Header';
import CompareTitle from '../../molecules/compare/compareTitle/CompareTitle';
import { NavigationBar } from '../../organisms/shared/navigationBar/NavigationBar';
import { getComponentsByType } from '../../../utils/utils';
import { CompareList } from '../../organisms/compare/compareList/CompareList';
import PopularCategories from '../../organisms/shared/popularCategories/PopularCategories';

export const Compare = ({
  sections,
  t,
  locale,
  menu,
  footer,
  siteUrls,
  location,
  search,
  handleDataLayer,
}) => {
  const systemSections = getComponentsByType(sections, 'compareSystems');
  const relatedCategories = sections.find(
    (section) => section.type === 'relatedCategories'
  );
  const general = systemSections.find((el) => el.type === 'general');
  const systems = systemSections.find((el) => el.type === 'systems');
  const systemNames = systems.componentData.map((item) => item.name);
  return (
    <div className="bg-primary-50">
      <div className="overflow-hidden">
        <NavigationBar
          data={menu}
          location={location}
          locale={locale}
          search={search}
          t={t}
        />
        <Header minimized />
      </div>

      <main>
        <CompareTitle
          data={systemNames}
          infoText={general?.componentData?.legalText}
        />
        <CompareList
          sections={systemSections}
          t={t}
          handleDataLayer={handleDataLayer}
        />
        <PopularCategories
          section={relatedCategories?.component}
          t={t}
          showAllCategoriesLink={false}
        />
      </main>
      <Footer data={footer} siteUrls={siteUrls} />
    </div>
  );
};

Compare.propTypes = {
  // sections: PropTypes.array,
};
